import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';

const PageHeader = ({ eyebrow, title, image }) => (
  <section className="relative h-[60vh] min-h-[440px] w-full overflow-hidden">
    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${image}')` }} />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0b2545]/60 via-[#0b2545]/40 to-[#0b2545]/70" />
    <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-end pb-16">
      <p className="text-xs tracking-[0.3em] text-[#9ec5e8] uppercase font-semibold">{eyebrow}</p>
      <h1
        className="text-white text-4xl md:text-6xl font-semibold mt-3 max-w-3xl leading-tight"
        style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}
      >
        {title}
      </h1>
    </div>
  </section>
);

export const PageShell = ({ eyebrow, title, image, children }) => (
  <div className="bg-white">
    <Navbar />
    <PageHeader eyebrow={eyebrow} title={title} image={image} />
    {children}
    <ContactSection />
    <Footer />
  </div>
);

export default PageShell;
